import React, { useId } from 'react';
import { StyledButtonGroupContainer } from './index.styles.js';
import {} from '../text-link/index.js';
import {} from '../text-button/index.js';
import {} from '@oneaudi/unified-web-common';
export const ButtonGroup = ({ className, children, orientation = 'horizontal', 'data-testid': dataTestId, margin }) => {
    const id = useId();
    const containsIconButton = React.Children.toArray(children).some((child) => {
        return (React.isValidElement(child) &&
            child.props.children === undefined &&
            child.props.icon !== undefined &&
            ['primary', 'secondary', 'tertiary'].includes(child.props.variant));
    });
    return (React.createElement(StyledButtonGroupContainer, { "data-testid": dataTestId, className: className, "$orientation": orientation, containsIconButtonOrLink: containsIconButton, margin: margin }, children.slice(0, 3).map((item, i) => {
        if (React.isValidElement(item) && item.props.children !== undefined) {
            return (React.createElement(React.Fragment, { key: i + id }, React.cloneElement(item, {
                isFullWidth: true
            })));
        }
        return React.createElement(React.Fragment, { key: i + id }, item);
    })));
};
//# sourceMappingURL=index.js.map